import React from 'react';
import PropTypes from 'prop-types';

import { CollapsibleContent } from 'components/Collapsible';

import { answerPropTypes } from './propTypes';
import ProductAnswersList from './ProductAnswersList';

// eslint-disable-next-line max-len
const ProductQuestionsAndAnswersCardCollapsibleMoreAnswers = ({
	open,
	collapsibleContentId,
	collapsibleDisclosureId,
	answers,
	pageNumber,
	questionPos,
	fromSearch = false
}) => (
	<CollapsibleContent
		open={open}
		collapsibleContentId={collapsibleContentId}
		collapsibleDisclosureId={collapsibleDisclosureId}
	>
		<div className="ProductQuestionsAndAnswersCard__answerCardList">
			<ProductAnswersList
				answers={answers}
				pageNumber={pageNumber}
				questionPos={questionPos}
				fromSearch={fromSearch}
			/>
		</div>
	</CollapsibleContent>
);
ProductQuestionsAndAnswersCardCollapsibleMoreAnswers.propTypes = {
	collapsibleContentId: PropTypes.string.isRequired,
	collapsibleDisclosureId: PropTypes.string.isRequired,
	open: PropTypes.bool.isRequired,
	answers: PropTypes.oneOfType([ PropTypes.shape({}), PropTypes.arrayOf(answerPropTypes) ]),
	pageNumber: PropTypes.number,
	questionPos: PropTypes.number,
	fromSearch: PropTypes.bool
};
export default ProductQuestionsAndAnswersCardCollapsibleMoreAnswers;
